export default __webpack_public_path__ + "static/media/icon_ue_provider.5c46629e.svg";